export enum LogEnum {
    ERROR = 'error',
    WARNING = 'warning'
}